export default __webpack_public_path__ + "static/media/facebook-hero.902230c1.svg";